import { DateTime } from 'luxon'

import type { QuestAvailability } from '../model/types'

export const QUEST_AVAILABILITIES: Array<{ slug: QuestAvailability; name: string }> = [
  { slug: 'open', name: 'Aberta' },
  { slug: 'soon', name: 'Aguardando' },
  { slug: 'closed', name: 'Encerrada' }
]

export const getQuestAvailability = (
  quest: { start_at: string | null; end_at: string | null },
  now: DateTime = DateTime.local()
): QuestAvailability => {
  const startAt = quest.start_at ? DateTime.fromISO(quest.start_at) : null
  const endAt = quest.end_at ? DateTime.fromISO(quest.end_at) : null

  if (startAt && now < startAt) return 'soon'
  if (endAt && now >= endAt) return 'closed'

  return 'open'
}
